import './TestimonialCard.css';

export const TestimonialCard = (props: {text:string, name:string}) => {
    return (
        <div className="testimonial-card">
      <div className="quote">❝</div>
      <p className="testimonial-text">{props.text}</p>
      <h3 className="testimonial-name">{props.name}</h3>
    </div>
    );
};